import { useTranslation } from "react-i18next"
import { alpha, Stack, Typography } from "@mui/material"
import PauseCircleOutlineIcon from "@mui/icons-material/PauseCircleOutline"

import LoadingButton from "widgets/common/LoadingButton"

interface AlertDisabledNoticeProps {
  canEnable: boolean
  isLoading: boolean
  onEnable: () => void
}

const AlertDisabledNotice = ({
  canEnable,
  isLoading,
  onEnable,
}: AlertDisabledNoticeProps) => {
  const { t } = useTranslation()

  return (
    <Stack
      direction={"row"}
      alignItems={"center"}
      gap={1.5}
      mb={2}
      sx={{
        py: 0.75,
        pl: 1.5,
        pr: 1,
        border: 1,
        borderColor: "neutral.300",
        borderRadius: 1,
        bgcolor: (theme) => alpha(theme.palette.text.primary, 0.04),
      }}
    >
      <PauseCircleOutlineIcon fontSize="small" sx={{ color: "text.secondary" }} />
      <Typography variant="body2" color="text.secondary" sx={{ flex: 1 }}>
        {t("alerts.DISABLED_NOTICE")}
      </Typography>
      {canEnable && (
        <LoadingButton
          type="button"
          variant="outlined"
          loading={isLoading}
          onClick={onEnable}
          aria-label={t("alerts.ENABLE")}
        >
          {t("alerts.ENABLE")}
        </LoadingButton>
      )}
    </Stack>
  )
}

export default AlertDisabledNotice
